import { render, staticRenderFns } from "./close-circle.vue?vue&type=template&id=6ae89770&"
import script from "./close-circle.vue?vue&type=script&lang=ts&"
export * from "./close-circle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports